import { memo } from 'react';

import { StatusChip } from './cells.styles';
import { DEFAULT_STATUS_COLORS, StatusColorConfig } from './statusColors';

export interface StatusCellProps {
  value: string | number | boolean | null | undefined;
  colors?: Record<string, StatusColorConfig>;
  /** Text shown on the chip; `value` alone still picks the colour, so a translated label keeps it. */
  label?: string;
}

export const StatusCell = memo(({ value, colors, label }: StatusCellProps) => {
  const normalizedValue = String(value).toLowerCase().replace(/\s+/g, '_');
  const statusConfig =
    colors?.[normalizedValue] ||
    DEFAULT_STATUS_COLORS[normalizedValue] ||
    DEFAULT_STATUS_COLORS.default;

  return value ? (
    <StatusChip
      label={label ?? value}
      statusbg={statusConfig.background}
      statuscolor={statusConfig.color}
    />
  ) : null;
});
StatusCell.displayName = 'StatusCell';
